<template lang="pug">

    person-form(
        ref="form"
        v-bind:companyModels='companyModels'
        v-bind:hideAddress='hideAddress'
        v-bind:hideCompany='hideCompany'
        v-model="model"
    )

</template>

<script>
    import PersonForm from './Form.vue'

    //noinspection ReservedWordAsName
    export default {

        components: { PersonForm },

        created() {
            // Wenn nur ein Unternehmen vorhanden, dann dieses setzen
            if (this.companyModels.length === 1) {
                this.model.company = this.companyModels[0].id
            }
        },

        data() {
            return {
                model: {}
            }
        },

        methods: {

            persist() {
                return this.$store.dispatch('persons/create', { model: this.model })
            },

            validate() {
                return this.$refs.form.validate()
            }

        },

        props: {

            companyModels: {
                type: Array,
                required: true
            },

            hideAddress: {
                type: Boolean,
                default: false
            },

            hideCompany: {
                type: Boolean,
                default: false
            }

        }


    }


</script>
